const setInitialSize = (htmlElement, receivedCssAttributes) => {
  let element;
  let cssAttributesWithInitialValues;
  let removeEvent;
  let handleSetSize;

  if (htmlElement) {
    cssAttributesWithInitialValues = {};
    element = htmlElement;

    const elementStyle = window.getComputedStyle(element);
    receivedCssAttributes.forEach(
      attribute =>
        (cssAttributesWithInitialValues[attribute] = elementStyle.getPropertyValue(attribute))
    );

    //function that recalculate the received css attributes depending on the browser zoom
    handleSetSize = () => {
      let zoom = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;

      if (element) {
        let setStyles = '';
        Object.keys(cssAttributesWithInitialValues).forEach(attribute => {
          const attributeValue = cssAttributesWithInitialValues[attribute];
          setStyles = setStyles + ` ${attribute}:calc(${attributeValue} * ${zoom})!important;`;
        });
        element.setAttribute('style', setStyles);
      }

      return removeEvent;
    };

    //function that will remove the event listener
    removeEvent = () => {
      window.removeEventListener('resize', handleSetSize, true);
    };

    window.addEventListener('resize', handleSetSize, true);

    return handleSetSize;
  }
};

export default setInitialSize;
